/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { orderConfirmationBillingInformationStyles } from "@insite/content-library/Widgets/OrderConfirmation/OrderConfirmationBillingInformation";
import {
    sharedAddressTitleStyle,
    sharedContentStyle,
} from "@monsma/App/WidgetExtensions/OrderApprovalDetails/OrderApprovalDetailsShippingInformationExtension";
import { css } from "styled-components";

orderConfirmationBillingInformationStyles.billingInformationGridContainer = {
    gap: 20,
    css: css`
        flex-direction: column;
    `,
};

orderConfirmationBillingInformationStyles.billingInformationBillingAddressGridItem = {
    width: 12,
    css: css`
        flex-direction: column;
    `,
};

orderConfirmationBillingInformationStyles.billingInformationCreditCardAddressGridItem = {
    width: 12,
    css: css`
        flex-direction: column;
    `,
};

orderConfirmationBillingInformationStyles.billingInformationTitleGridItem = {
    css: css`
        display: none !important;
    `,
};

orderConfirmationBillingInformationStyles.billingAddressTitle = sharedAddressTitleStyle;

orderConfirmationBillingInformationStyles.billingAddress = sharedContentStyle;

orderConfirmationBillingInformationStyles.billingCreditCardAddressTitle = sharedAddressTitleStyle;

orderConfirmationBillingInformationStyles.creditCardBillingAddress = sharedContentStyle;
